export default "__VITE_ASSET__DFe36Yws__"